import Vue from 'vue'
import App from './App.vue'
import store from './store'
import Common from './lib/common'
import axios from 'axios'
import VueRouter from 'vue-router'
import Vant from 'vant';
import { Loading } from 'vant';
import { Toast } from 'vant';
import 'vant/lib/index.css';
import router from './router'
// import Meta from 'vue-meta';


Vue.use(VueRouter)
Vue.use(Vant);
Vue.use(Loading);
Vue.use(Toast);
// Vue.use(Meta);
Vue.prototype.$axios = axios;
// Vue.use(Element)
Vue.config.productionTip = false
Vue.prototype.common = Common
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
    console.log('===>', window.location.search)
    var ua = window.navigator.userAgent.toLowerCase();
    let url = window.location.href
    //通过正则表达式匹配ua中是否含有MicroMessenger字符串
    // console.log($('#wx_JSSDKConfig p').html())

    // $('meta[property="og:description"]').attr('content', "***");
    $("meta[name ='description']").attr('content', '官方自营 支持比价 极速配送 平台背书 比品牌自营价再低20%-50%');
    $('#wx_JSSDKConfig p').html('官方自营 支持比价 极速配送 平台背书 比品牌自营价再低20%-50%')

    document.getElementById('wx_JSSDKConfig').setAttribute('data-link', window.location.href)


  }
  next();

});
// 获取input焦点
Vue.directive('focus', {
  inserted: function (el) {
    el.focus()
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')